export default __webpack_public_path__ + "static/media/ordercomplete.e0810d3d.png";